import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import CardWrapper from 'components/Common/CardWrapper';
import PaymentTokenList from './PaymentTokenList';
import { searchPaymentAuthRequestHistory } from 'redux/slices/user/authRequestSlice';

const StoredPaymentTokens = () => {
    const dispatch = useDispatch<AppDispatch>();

    const loadData = async (page: number, pageSize: number, debouncedSearchText: string, sortOrder: string) => {
        let payload: any = {
            offset: page,
            pageSize,
            sortOrder,
        };
        if (debouncedSearchText) {
            payload = { ...payload, nickname: debouncedSearchText };
        }
        const result = await dispatch(searchPaymentAuthRequestHistory(payload as any));

        return result?.payload || [];
    };

    return (
        <CardWrapper hideButton={true}>
            <PaymentTokenList loadData={loadData} />
        </CardWrapper>
    );
};

export default StoredPaymentTokens;
